var _defs, _rect, _path, _rect2, _rect3, _path2, _circle, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path3, _path4, _rect11, _path5, _circle2, _circle3, _circle4, _path6, _rect12, _rect13, _path7, _circle5, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _circle6, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle7, _path15, _path16, _polygon, _path17, _path18, _path19, _path20, _path21, _path22, _ellipse, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _ellipse2, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _rect22, _path51, _rect23, _path52, _path53, _path54, _path55, _path56, _line, _path57, _path58, _path59, _path60, _line2, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _circle8, _circle9, _circle10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsiteDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "WEBSITE",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1600 1400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#262424;}.cls-3{fill:#de9244;}.cls-4{fill:#88c0c2;}.cls-5{fill:#87bfc1;}.cls-6{fill:#dd9144;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Website Design") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 699.95,
    y: 286.66,
    width: 683.84,
    height: 499.95,
    rx: 13,
    ry: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1371.65,788.95H712.09a14.49,14.49,0,0,1-14.47-14.47V298.8a14.49,14.49,0,0,1,14.47-14.47h659.57a14.49,14.49,0,0,1,14.47,14.47V774.48A14.49,14.49,0,0,1,1371.65,788.95ZM712.09,289a9.81,9.81,0,0,0-9.8,9.8V774.48a9.81,9.81,0,0,0,9.8,9.8h659.57a9.81,9.81,0,0,0,9.8-9.8V298.8a9.81,9.81,0,0,0-9.8-9.8H712.09Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 760.11,
    y: 379.68,
    width: 300.43,
    height: 210.48,
    rx: 10,
    ry: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 778.13,
    y: 396.2,
    width: 264.39,
    height: 177.44
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1042.51,549v24.64H778.13v-56l48.11-48.1a18.67,18.67,0,0,1,26.42,0l70.59,70.59,42-42a18.67,18.67,0,0,1,26.42,0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 928.16,
    cy: 465.01,
    r: 20.31
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1096.02,
    y: 379.68,
    width: 227.61,
    height: 210.48,
    rx: 10,
    ry: 10
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1134.72,
    y: 425.67,
    width: 150.21,
    height: 18.36,
    rx: 7.5,
    ry: 7.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1134.72,
    y: 475.74,
    width: 150.21,
    height: 18.36,
    rx: 7.5,
    ry: 7.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1134.72,
    y: 525.81,
    width: 150.21,
    height: 18.36,
    rx: 7.5,
    ry: 7.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 918.95,
    y: 659.51,
    width: 398.15,
    height: 28.49,
    rx: 14.25,
    ry: 14.25
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 918.95,
    y: 706.99,
    width: 398.15,
    height: 28.49,
    rx: 14.25,
    ry: 14.25
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 792.94,
    y: 647.77,
    width: 99.44,
    height: 99.44,
    rx: 6.87,
    ry: 6.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M882.84,739.22a2.33,2.33,0,0,1-1.65-.68l-81.93-81.93a2.33,2.33,0,0,1,3.3-3.3l81.93,81.93A2.33,2.33,0,0,1,882.84,739.22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M800.92,739.22a2.33,2.33,0,0,1-1.65-4l81.93-81.93a2.33,2.33,0,1,1,3.3,3.3l-81.93,81.93A2.33,2.33,0,0,1,800.92,739.22Z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 684.83,
    y: 248.99,
    width: 714.08,
    height: 77.9,
    rx: 13.67,
    ry: 13.67
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1386.15,329.22H697.59a15.11,15.11,0,0,1-15.09-15.09V261.75a15.11,15.11,0,0,1,15.09-15.09h688.56a15.11,15.11,0,0,1,15.09,15.09v52.38A15.11,15.11,0,0,1,1386.15,329.22Zm-688.56-77.9a10.44,10.44,0,0,0-10.43,10.43v52.38a10.44,10.44,0,0,0,10.43,10.43h688.56a10.44,10.44,0,0,0,10.42-10.43V261.75a10.44,10.44,0,0,0-10.42-10.43H697.59Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 717.22,
    cy: 287.94,
    r: 16.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 791.42,
    cy: 287.94,
    r: 16.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 865.61,
    cy: 287.94,
    r: 16.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1062.27,1143.5h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,0,1,1062.27,1143.5Zm-24,0h-12a2.5,2.5,0,1,1,0-5h12A2.5,2.5,0,0,1,1038.27,1143.5Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,1,1,1014.27,1143.5Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,1,1,990.27,1143.5Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,1,1,966.27,1143.5Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,1,1,942.27,1143.5Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,1,1,918.27,1143.5Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,1,1,894.27,1143.5Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,1,1,870.27,1143.5Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,1,1,846.27,1143.5Zm-24,0h-1.46a2.5,2.5,0,0,1-2.5-2.5v-12a2.5,2.5,0,0,1,5,0v9.73A2.5,2.5,0,0,1,822.27,1143.5Zm251.67-.33a2.5,2.5,0,0,1-2.5-2.5v-12a2.5,2.5,0,1,1,5,0v12A2.5,2.5,0,0,1,1073.94,1143.17ZM820.81,1119.5a2.5,2.5,0,0,1-2.5-2.5v-12a2.5,2.5,0,0,1,5,0v12A2.5,2.5,0,0,1,820.81,1119.5Zm253.13-.33a2.5,2.5,0,0,1-2.5-2.5v-12a2.5,2.5,0,1,1,5,0v12A2.5,2.5,0,0,1,1073.94,1119.17ZM820.81,1095.5a2.5,2.5,0,0,1-2.5-2.5v-12a2.5,2.5,0,0,1,5,0v12A2.5,2.5,0,0,1,820.81,1095.5Zm253.13-.33a2.5,2.5,0,0,1-2.5-2.5v-12a2.5,2.5,0,1,1,5,0v12A2.5,2.5,0,0,1,1073.94,1095.17ZM820.81,1071.5a2.5,2.5,0,0,1-2.5-2.5v-12a2.5,2.5,0,0,1,5,0v12A2.5,2.5,0,0,1,820.81,1071.5Zm253.13-.33a2.5,2.5,0,0,1-2.5-2.5v-12a2.5,2.5,0,1,1,5,0v12A2.5,2.5,0,0,1,1073.94,1071.17ZM820.81,1047.5a2.5,2.5,0,0,1-2.5-2.5v-12a2.5,2.5,0,0,1,5,0v12A2.5,2.5,0,0,1,820.81,1047.5Zm253.13-.33a2.5,2.5,0,0,1-2.5-2.5v-12a2.5,2.5,0,1,1,5,0v12A2.5,2.5,0,0,1,1073.94,1047.17ZM820.81,1023.5a2.5,2.5,0,0,1-2.5-2.5v-12a2.5,2.5,0,0,1,5,0v12A2.5,2.5,0,0,1,820.81,1023.5Zm253.13-.33a2.5,2.5,0,0,1-2.5-2.5v-12a2.5,2.5,0,1,1,5,0v12A2.5,2.5,0,0,1,1073.94,1023.17ZM820.81,999.5a2.5,2.5,0,0,1-2.5-2.5V985a2.5,2.5,0,1,1,5,0v12A2.5,2.5,0,0,1,820.81,999.5Zm253.13-.33a2.5,2.5,0,0,1-2.5-2.5v-12a2.5,2.5,0,0,1,5,0v12A2.5,2.5,0,0,1,1073.94,999.17ZM820.81,975.5a2.5,2.5,0,0,1-2.5-2.5V961a2.5,2.5,0,1,1,5,0v12A2.5,2.5,0,0,1,820.81,975.5Zm253.13-.33a2.5,2.5,0,0,1-2.5-2.5v-12a2.5,2.5,0,0,1,5,0v12A2.5,2.5,0,0,1,1073.94,975.17ZM820.81,951.5a2.5,2.5,0,0,1-2.5-2.5V937a2.5,2.5,0,1,1,5,0v12A2.5,2.5,0,0,1,820.81,951.5Zm253.13-.33a2.5,2.5,0,0,1-2.5-2.5v-12a2.5,2.5,0,0,1,5,0v12A2.5,2.5,0,0,1,1073.94,951.17ZM820.81,927.5a2.5,2.5,0,0,1-2.5-2.5V913a2.5,2.5,0,1,1,5,0v12A2.5,2.5,0,0,1,820.81,927.5Zm253.13-.33a2.5,2.5,0,0,1-2.5-2.5v-12a2.5,2.5,0,0,1,5,0v12A2.5,2.5,0,0,1,1073.94,927.17Zm-0.73-23.27h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,0,1,1073.21,903.9Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,0,1,1049.21,903.9Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,0,1,1025.21,903.9Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,0,1,1001.21,903.9Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,1,1,977.21,903.9Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,1,1,953.21,903.9Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,1,1,929.21,903.9Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,1,1,905.21,903.9Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,1,1,881.21,903.9Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,1,1,857.21,903.9Zm-24,0h-12a2.5,2.5,0,0,1,0-5h12A2.5,2.5,0,1,1,833.21,903.9Z"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 844.41,
    y: 925,
    width: 205.94,
    height: 192.41,
    rx: 10,
    ry: 10
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 858.04,
    y: 938.31,
    width: 178.68,
    height: 165.78
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1036.72,1087.44v16.65H858v-37.85l32.51-32.51a12.62,12.62,0,0,1,17.85,0l47.7,47.7,28.38-28.38a12.62,12.62,0,0,1,17.85,0Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 959.44,
    cy: 1030.68,
    r: 13.72
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 807.39,
    y: 887.98,
    width: 26.85,
    height: 26.85,
    rx: 3.92,
    ry: 3.92
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 932.2,
    y: 887.98,
    width: 26.85,
    height: 26.85,
    rx: 3.92,
    ry: 3.92
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1057.02,
    y: 887.98,
    width: 26.85,
    height: 26.85,
    rx: 3.92,
    ry: 3.92
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 807.39,
    y: 1127.57,
    width: 26.85,
    height: 26.85,
    rx: 3.92,
    ry: 3.92
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 932.2,
    y: 1127.57,
    width: 26.85,
    height: 26.85,
    rx: 3.92,
    ry: 3.92
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1057.02,
    y: 1127.57,
    width: 26.85,
    height: 26.85,
    rx: 3.92,
    ry: 3.92
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 807.39,
    y: 1007.77,
    width: 26.85,
    height: 26.85,
    rx: 3.92,
    ry: 3.92
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1057.02,
    y: 1007.77,
    width: 26.85,
    height: 26.85,
    rx: 3.92,
    ry: 3.92
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 551.07,
    cy: 426.5,
    r: 83.78
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540.76,456.08h0a7.07,7.07,0,0,1-6.43-10L555,401a7.07,7.07,0,0,1,6.43-4.13h0a7.07,7.07,0,0,1,6.43,10l-20.62,45A7.07,7.07,0,0,1,540.76,456.08Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M515.08,426.51l8.21,8.2a4.46,4.46,0,0,1-3.15,7.61h0A4.46,4.46,0,0,1,517,441l-13.1-13.09a2,2,0,0,1,0-2.83L517,412a4.46,4.46,0,0,1,3.15-1.31h0a4.46,4.46,0,0,1,3.15,7.61Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M587.07,426.51l-8.21,8.2a4.46,4.46,0,0,0,3.15,7.61h0a4.46,4.46,0,0,0,3.15-1.3l13.1-13.09a2,2,0,0,0,0-2.83L585.16,412a4.46,4.46,0,0,0-3.15-1.31h0a4.46,4.46,0,0,0-3.15,7.61Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M658.69,547.14c0-.39,5.83-27.44,9.18-42.94A13.45,13.45,0,0,1,681,493.59h27.39l12.86-33.81a5.47,5.47,0,0,1,5.11-3.53h0a5.47,5.47,0,0,1,5.37,6.49l-7.87,41.41,3.33,3.33a13.45,13.45,0,0,1,3.31,13.57l-2.65,8.37a33.64,33.64,0,0,1-15.51,19.13L689.11,561.7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M689.11,564.2A2.5,2.5,0,0,1,688,564l-30.41-14.57a2.5,2.5,0,0,1-1.42-2.25c0-.4,0-0.71,9.24-43.47A16,16,0,0,1,681,491.09h25.67l12.25-32.2a8,8,0,0,1,15.28,4.32l-7.62,40.11,2.39,2.39a15.9,15.9,0,0,1,3.93,16.09l-2.65,8.37a36,36,0,0,1-16.67,20.55l-23.27,13.16A2.5,2.5,0,0,1,689.11,564.2Zm-27.58-18.49L689,558.89l22.13-12.51a31,31,0,0,0,14.36-17.71l2.65-8.37a10.92,10.92,0,0,0-2.7-11l-3.33-3.33a2.5,2.5,0,0,1-.69-2.23l7.87-41.41a3,3,0,0,0-5.69-1.61l-12.86,33.81a2.5,2.5,0,0,1-2.34,1.61H681a11,11,0,0,0-10.7,8.63C665.63,526.43,662.53,540.86,661.52,545.72Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M694.39,567.35L651,648.4l-9.12,17.06a47.66,47.66,0,0,1-17.36,18.29l-13.45,8.12L501.52,758s-85.65-56.23-10.8-101l91.66-31.71,72.12-83.59S677.45,536.21,694.39,567.35Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M677.46,581.14a2.5,2.5,0,0,1-2-1c-10.59-14.18-26.72-17.4-26.88-17.44a2.5,2.5,0,0,1,.94-4.91,53.12,53.12,0,0,1,29.94,19.35A2.5,2.5,0,0,1,677.46,581.14Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 680.8,
    cy: 564.41,
    r: 4.17
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M680.8,571.08a6.67,6.67,0,1,1,6.67-6.67A6.67,6.67,0,0,1,680.8,571.08Zm0-8.33a1.67,1.67,0,1,0,1.67,1.67A1.67,1.67,0,0,0,680.8,562.75Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M651,648.4l-9.12,17.06a47.66,47.66,0,0,1-17.36,18.29l-13.45,8.12a22.78,22.78,0,0,1-4.05-4.66c-8-12.1-3.32-29.25,10.41-38.31C628.49,641.62,642,641.78,651,648.4Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "274.78 999.27 242.63 1113.49 527.82 1113.49 500.47 995.85 274.78 999.27"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.64,1071.15h0a46.58,46.58,0,0,0,35.14,55.7l173.45,39.3H543.9l92-48.24a44.05,44.05,0,0,0,17.51-61.36h0a44.05,44.05,0,0,0-38-21.71H222.08A46.58,46.58,0,0,0,176.64,1071.15Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M425.41,1065.89a2.5,2.5,0,0,1-1.77-4.27l2.32-2.32a21.55,21.55,0,0,0,6.35-15.33v-41.62a2.5,2.5,0,0,1,5,0V1044a26.51,26.51,0,0,1-7.82,18.87l-2.32,2.32A2.49,2.49,0,0,1,425.41,1065.89Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M423.87,1102.65a2.5,2.5,0,0,1-2.5-2.5V996.88a2.5,2.5,0,0,1,5,0v103.27A2.5,2.5,0,0,1,423.87,1102.65Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M216.75,1142.77a84.7,84.7,0,0,0,18.11,52.44h82.42l14.52-6.05,47-19.59L358,1132.64l-94.82-21a78.48,78.48,0,0,0-13-1.77,79.37,79.37,0,0,0-28.29,3.64S216.75,1125.48,216.75,1142.77Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.52,1154.52s-49.58-2.91-74.55-6a62.43,62.43,0,0,0-8.21-22.74c42.06,8.21,80.53,12.48,80.53,12.48Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M360.52,1157h-0.15c-0.5,0-49.95-2.95-74.71-6a2.5,2.5,0,0,1-2.16-2.07,59.61,59.61,0,0,0-7.87-21.84,2.5,2.5,0,0,1,2.61-3.76c41.47,8.09,79.94,12.41,80.33,12.45a2.5,2.5,0,0,1,2.2,2.15l2.22,16.24A2.5,2.5,0,0,1,360.52,1157Zm-72.41-10.75c21.42,2.52,58.68,4.9,69.52,5.57l-1.55-11.3c-7.95-.94-39.2-4.79-73.55-11.28A65.84,65.84,0,0,1,288.11,1146.28Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 334.71,
    cy: 1169.57,
    rx: 13.42,
    ry: 7.95,
    transform: "translate(-491.93 277.06) rotate(-26.84)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.75,1142.77a84.7,84.7,0,0,0,18.11,52.44h82.42l14.52-6.05-67.52-3.87s37.48-46.19-13.08-74.89c-0.35-.19-0.69-0.39-1-0.56a79.37,79.37,0,0,0-28.29,3.64S216.75,1125.48,216.75,1142.77Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M317.27,1197.72H234.85a2.5,2.5,0,0,1-2-1c-12.36-16.07-18.62-34.23-18.62-54,0-17.6,5.1-29.76,5.32-30.27a2.5,2.5,0,0,1,1.54-1.4,81.49,81.49,0,0,1,29.18-3.76,2.5,2.5,0,0,1,1,.27l0.85,0.46,0.25,0.14c15.4,8.74,24.48,20,27,33.38,3.35,17.73-5.67,34.23-10.46,41.46l63,3.61a2.5,2.5,0,0,1,.82,4.8l-14.52,6.05A2.51,2.51,0,0,1,317.27,1197.72Zm-81.18-5h80.68l4-1.68-56.67-3.25a2.5,2.5,0,0,1-1.8-4.07c0.16-.2,16.14-20.26,12.17-41.22-2.25-11.89-10.51-22-24.54-29.92l-0.25-.14-0.23-.13a76.7,76.7,0,0,0-25.71,3.2,82.57,82.57,0,0,0-4.52,27.26A81.73,81.73,0,0,0,236.09,1192.72Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M362.75,1179.14S627.07,1150.46,652,1133a43.81,43.81,0,0,0,13.16-15.47c12.28-23.06,10.28-58.87-16.16-74.69-8.32-5-19.05-8-32.53-8l-262,91S336.59,1152.47,362.75,1179.14Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M362.75,1181.64a2.5,2.5,0,0,1-1.78-.75c-27.27-27.81-8.69-56.21-8.5-56.49a2.5,2.5,0,0,1,1.25-1l261.46-90.79a2.5,2.5,0,1,1,1.64,4.72l-260.63,90.5c-2.48,4.17-13.79,26.1,7.5,48.65,15.44-1.7,172-19.09,247.94-34.43a2.5,2.5,0,1,1,1,4.9c-79.73,16.12-247.92,34.46-249.61,34.64h-0.27Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.32,1126.82s-8.89,17.78,6.5,39.32"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.82,1168.65a2.49,2.49,0,0,1-2-1c-16.08-22.51-7.09-41.12-6.7-41.9a2.5,2.5,0,0,1,4.48,2.23c-0.34.68-8,16.81,6.29,36.76A2.5,2.5,0,0,1,378.82,1168.65Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M602.13,1083.21a40.86,40.86,0,0,0,63.07,34.29c12.28-23.06,10.28-58.87-16.16-74.69A40.86,40.86,0,0,0,602.13,1083.21Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M621.85,1142.77a84.7,84.7,0,0,1-18.11,52.44H521.32l-14.52-6.05-47-19.59c-5.21-19.28,3.67-36.82,20.87-36.93l94.82-21a78.48,78.48,0,0,1,13-1.77,79.37,79.37,0,0,1,28.29,3.64S621.85,1125.48,621.85,1142.77Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M603.74,1197.72H521.32a2.5,2.5,0,0,1-1-.19l-61.55-25.65a2.5,2.5,0,0,1-1.45-1.66c-3.13-11.57-1.48-23.09,4.4-30.82a23.32,23.32,0,0,1,18.6-9.26l94.57-21a81.67,81.67,0,0,1,42.57,1.93,2.5,2.5,0,0,1,1.54,1.4c0.22,0.51,5.32,12.67,5.32,30.27,0,19.74-6.27,37.89-18.62,54A2.5,2.5,0,0,1,603.74,1197.72Zm-81.92-5H602.5a81.73,81.73,0,0,0,16.85-49.94,82.59,82.59,0,0,0-4.52-27.26,76.67,76.67,0,0,0-38.83-1.46l-94.82,21a2.5,2.5,0,0,1-.52.06,18.21,18.21,0,0,0-14.92,7.29c-4.75,6.25-6.16,15.64-3.85,25.31Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M478.07,1154.52s49.58-2.91,74.55-6a62.43,62.43,0,0,1,8.21-22.74c-42.06,8.21-80.53,12.48-80.53,12.48Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M478.07,1157a2.5,2.5,0,0,1-2.48-2.84l2.22-16.24a2.5,2.5,0,0,1,2.2-2.15c0.38,0,38.86-4.36,80.33-12.45a2.5,2.5,0,0,1,2.61,3.76,59.64,59.64,0,0,0-7.87,21.84,2.5,2.5,0,0,1-2.16,2.07c-24.76,3.05-74.21,6-74.71,6h-0.15Zm4.44-16.48-1.55,11.3c10.84-.67,48.1-3,69.52-5.57a65.84,65.84,0,0,1,5.58-17C521.7,1135.75,490.45,1139.6,482.51,1140.54Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 503.88,
    cy: 1169.57,
    rx: 7.95,
    ry: 13.42,
    transform: "translate(-767.2 1091.2) rotate(-63.16)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M621.85,1142.77a84.7,84.7,0,0,1-18.11,52.44H521.32l-14.52-6.05,67.52-3.87s-37.48-46.19,13.08-74.89c0.35-.19.69-0.39,1-0.56a79.37,79.37,0,0,1,28.29,3.64S621.85,1125.48,621.85,1142.77Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M603.74,1197.72H521.32a2.5,2.5,0,0,1-1-.19l-14.52-6.05a2.5,2.5,0,0,1,.82-4.8l63-3.61c-4.79-7.23-13.81-23.72-10.46-41.46,2.53-13.42,11.61-24.64,27-33.37l0.25-.14,0.86-.47a2.51,2.51,0,0,1,1-.27,81.51,81.51,0,0,1,29.18,3.76,2.5,2.5,0,0,1,1.54,1.4c0.22,0.51,5.32,12.67,5.32,30.27,0,19.74-6.27,37.89-18.62,54A2.5,2.5,0,0,1,603.74,1197.72Zm-81.92-5H602.5a83.15,83.15,0,0,0,12.33-77.2,76.56,76.56,0,0,0-25.71-3.2l-0.24.14-0.25.14c-14,8-22.27,18-24.53,29.91-4,21,12,41,12.17,41.22a2.5,2.5,0,0,1-1.8,4.07L517.8,1191Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.53,1125.8l40,10s7.18,19.75-9.49,26.93l-47.19-6.67Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M474.05,1165.23l-0.35,0-47.19-6.67a2.5,2.5,0,0,1-1.84-3.68l16.67-30.26a2.51,2.51,0,0,1,2.8-1.22l40,10a2.5,2.5,0,0,1,1.74,1.57c2.76,7.6,4.05,23.66-10.85,30.08A2.5,2.5,0,0,1,474.05,1165.23Zm-43.25-11.14,42.88,6.06c11.51-5.44,9-18.21,7.89-22.27l-36.78-9.19Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M442,1177.77s-230.47-27.32-255.44-44.8a43.81,43.81,0,0,1-13.16-15.47c-12.28-23.06-10.28-58.87,16.16-74.69,8.32-5,19.05-8,32.53-8l231.2,83.44S468.15,1151.1,442,1177.77Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M442,1180.27l-0.29,0c-1.49-.18-149.81-17.84-220.53-33.69a2.5,2.5,0,1,1,1.09-4.88c67,15,204.29,31.71,218.79,33.45,21.19-22.53,12.38-49.55,10.33-54.9l-197.1-71.13a2.5,2.5,0,0,1,1.7-4.7l198.14,71.51a2.5,2.5,0,0,1,1.43,1.32c0.16,0.34,15.27,34.71-11.78,62.28A2.5,2.5,0,0,1,442,1180.27Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M425.92,1167.28a2.5,2.5,0,0,1-2-4c14.55-20.38,9.23-43.21,9.18-43.44a2.5,2.5,0,1,1,4.86-1.18c0.25,1,5.9,25.3-10,47.52A2.5,2.5,0,0,1,425.92,1167.28Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.46,1083.21a40.86,40.86,0,0,1-63.07,34.29c-12.28-23.06-10.28-58.87,16.16-74.69A40.86,40.86,0,0,1,236.46,1083.21Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M305.55,689.29s60-43.09,185.17-32.31c0,0,35.39,30.26,27.19,120s-10.26,228.77-10.26,228.77h-239S267.08,865.23,305.55,689.29Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M490.89,992.54H278.2a2.5,2.5,0,1,1,0-5h212.7A2.5,2.5,0,0,1,490.89,992.54Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M518.85,741.56a2.5,2.5,0,0,1-2.5-2.38c-2.07-42.21-15-65-22.47-74.88a2.5,2.5,0,0,1,4-3c7.85,10.31,21.35,34.11,23.48,77.67a2.5,2.5,0,0,1-2.37,2.62h-0.12Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.87,680.78a52.7,52.7,0,0,0,33.25,29.82c2.48-13.6,9.31-30.71,9.31-30.71C421,690.34,425,704.15,426,710.45c24.57-6.75,27.37-30.37,27.37-30.37-3-23.67-23.35-41.49-40.82-40.89C373.95,640.5,370.87,680.78,370.87,680.78Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.11,713.1a2.52,2.52,0,0,1-.75-0.11,55.45,55.45,0,0,1-34.8-31.22,2.5,2.5,0,0,1-.2-1.18c0-.43,3.72-42.53,44.09-43.9,17.87-.6,40.07,16.94,43.39,43.08a2.47,2.47,0,0,1,0,.61c0,0.25-3.3,25.37-29.19,32.49a2.5,2.5,0,0,1-3.13-2A79.62,79.62,0,0,0,414,685.36c-2.17,5.95-5.81,16.68-7.46,25.69A2.5,2.5,0,0,1,404.11,713.1Zm-30.69-32.72a50.23,50.23,0,0,0,28.8,26.93c2.81-13.07,8.62-27.68,8.88-28.34a2.5,2.5,0,0,1,4.34-.54c7.06,9.72,11,21.82,12.49,28.81,19.14-6.67,22.52-24.55,22.91-27.16-3-22.63-22.65-38.91-38.21-38.39-15.07.51-26.24,7.24-33.21,20A54.43,54.43,0,0,0,373.42,680.38Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M663.8,1068.35h-193a8.55,8.55,0,0,1-8.28-10.69L504.28,896.6a8.55,8.55,0,0,1,8.28-6.4h193a8.55,8.55,0,0,1,8.28,10.69l-41.73,161.06A8.55,8.55,0,0,1,663.8,1068.35Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M663.8,1070.85h-193a11,11,0,0,1-10.7-13.82L501.86,896a11,11,0,0,1,10.7-8.28h193a11,11,0,0,1,10.7,13.82L674.5,1062.57A11,11,0,0,1,663.8,1070.85ZM512.56,892.69a6.05,6.05,0,0,0-5.86,4.53L465,1058.28a6,6,0,0,0,5.86,7.57h193a6,6,0,0,0,5.86-4.53l41.73-161.06a6,6,0,0,0-5.86-7.57h-193Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M678.85,1068.35h-193a8.55,8.55,0,0,1-8.28-10.69L519.33,896.6a8.55,8.55,0,0,1,8.28-6.4h193a8.55,8.55,0,0,1,8.28,10.69l-41.73,161.06A8.55,8.55,0,0,1,678.85,1068.35Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M678.85,1070.85h-193a11,11,0,0,1-10.7-13.82L516.91,896a11,11,0,0,1,10.7-8.28h193a11,11,0,0,1,10.7,13.82l-41.73,161.06A11,11,0,0,1,678.85,1070.85ZM527.6,892.69a6,6,0,0,0-5.86,4.53L480,1058.28a6,6,0,0,0,5.86,7.57h193a6,6,0,0,0,5.86-4.53l41.73-161.06a6,6,0,0,0-5.86-7.57h-193Z"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 439.94,
    y: 1068.35,
    width: 231.04,
    height: 17.1,
    rx: 8.33,
    ry: 8.33,
    transform: "translate(1110.92 2153.79) rotate(-180)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M662.65,1087.95H448.28a10.85,10.85,0,0,1-10.83-10.83v-0.43a10.85,10.85,0,0,1,10.83-10.83H662.65a10.85,10.85,0,0,1,10.83,10.83v0.43A10.85,10.85,0,0,1,662.65,1087.95Zm-214.37-17.1a5.84,5.84,0,0,0-5.83,5.83v0.43a5.84,5.84,0,0,0,5.83,5.83H662.65a5.84,5.84,0,0,0,5.83-5.83v-0.43a5.84,5.84,0,0,0-5.83-5.83H448.28Z"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 294.61,
    y: 1068.35,
    width: 165.16,
    height: 17.1,
    rx: 8.33,
    ry: 8.33
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M451.44,1087.95H302.94a10.85,10.85,0,0,1-10.83-10.83v-0.43a10.85,10.85,0,0,1,10.83-10.83h148.5a10.85,10.85,0,0,1,10.83,10.83v0.43A10.85,10.85,0,0,1,451.44,1087.95Zm-148.5-17.1a5.84,5.84,0,0,0-5.83,5.83v0.43a5.84,5.84,0,0,0,5.83,5.83h148.5a5.84,5.84,0,0,0,5.83-5.83v-0.43a5.84,5.84,0,0,0-5.83-5.83H302.94Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M375.57,1022.7l-31,21.54S289.27,996.1,259.41,961c-10.21-12-17.44-22.51-18.49-29-0.87-5.43-.11-18.76,2-36.56,7.75-66.26,33.81-194.33,62.67-206.05C322,682.62,342,698,340.95,737.51S319.4,911.39,319.4,911.39Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.36,1004.18a2.49,2.49,0,0,1-1.74-.7c-9.77-9.47-18.5-18.29-25.93-26.21a2.5,2.5,0,1,1,3.65-3.42c7.38,7.87,16,16.63,25.76,26A2.5,2.5,0,0,1,298.36,1004.18Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.7,1032.21a2.5,2.5,0,0,1-1.38-4.59l25.82-17a2.5,2.5,0,0,1,2.75,4.17h0l-24.48,16.15-0.24.14-1.09.72A2.49,2.49,0,0,1,337.7,1032.21Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363.81,1001.88a2.5,2.5,0,0,1-2.23-1.37l-44.4-88a2.5,2.5,0,0,1-.24-1.5c0.2-1.34,20.5-134.68,21.52-173.57,0.75-28.83-9.75-42.78-19.82-46.23a2.5,2.5,0,0,1,1.62-4.73c11.75,4,24,19.55,23.2,51.09-1,37.62-19.76,162.24-21.45,173.4l44,87.28A2.5,2.5,0,0,1,363.81,1001.88Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 319.4,
    y1: 911.39,
    x2: 288.11,
    y2: 920.28
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.11,922.78a2.5,2.5,0,0,1-.68-4.91L318.72,909a2.5,2.5,0,0,1,1.37,4.81l-31.29,8.89A2.51,2.51,0,0,1,288.11,922.78Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.41,961c-10.21-12-17.44-22.51-18.49-29-0.87-5.43-.11-18.76,2-36.56,11.55,0,23.36,11.14,27.79,27.26C275.31,939.42,270.29,955.73,259.41,961Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.49,1042.89s5.1,14.31,17.67,13.54c0,0,16.29,18.08,24.11,19s24-6.41,24.49-13.59c0,0,9.1-.13,8-9.36s-15.9-34.24-24.62-37.19S367.52,1026.73,346.49,1042.89Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M389.61,1078a14.32,14.32,0,0,1-1.63-.09c-7.75-.89-21.23-15-24.9-18.93-13.38,0-18.72-14.59-18.95-15.23a2.5,2.5,0,0,1,.83-2.82c26.71-20.52,42.9-31.06,51.92-28,9.82,3.32,25,29,26.3,39.25,0.44,3.49-.3,6.37-2.19,8.54a11,11,0,0,1-6.18,3.39,14.18,14.18,0,0,1-4.61,6C404.78,1074.6,395.79,1078,389.61,1078Zm-25.46-24.05a2.5,2.5,0,0,1,1.86.83c6.05,6.72,17.53,17.59,22.54,18.17,4.79,0.54,13.6-2.63,18.47-6.67,2-1.66,3.15-3.3,3.25-4.61a2.5,2.5,0,0,1,2.46-2.32s2.94-.1,4.52-1.93a5.77,5.77,0,0,0,1-4.62c-1.14-9.1-15.73-32.69-22.94-35.13-7.93-2.67-31,14.75-45.73,26.06,1.64,3.39,6.17,10.75,14.45,10.24h0.15Zm-17.67-11h0Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 396.21,
    y1: 1036.93,
    x2: 410.45,
    y2: 1057.96
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M410.45,1060.46a2.5,2.5,0,0,1-2.07-1.1l-14.23-21a2.5,2.5,0,0,1,4.14-2.8l14.23,21A2.5,2.5,0,0,1,410.45,1060.46Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389.95,591.48l0.63,23.73,1.07,40.6c13.66,9.55,26.94,10.55,39.75.93l-1.88-18.86-2.84-28.57Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.86,666q-11,0-22.64-8.13a2.5,2.5,0,0,1-1.07-2l-1.7-64.33a2.5,2.5,0,0,1,3.59-2.32l36.74,17.84a2.5,2.5,0,0,1,1.4,2l4.72,47.43a2.5,2.5,0,0,1-1,2.25C426.47,663.58,419.77,666,412.86,666Zm-18.74-11.52c12.45,8.3,23.81,8.66,34.66,1.09L424.33,611l-31.78-15.43Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M455.07,585c2.15,19.51,1.5,43.53-22.17,44.87C404.76,631.45,383,616,377.24,590.1s3-43,34.71-46.69a48.69,48.69,0,0,1,8.12-.28c18.89,1,31,13.88,33.63,31.48C454.16,577.79,454.67,581.31,455.07,585Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M429,632.47a59.89,59.89,0,0,1-27.63-6.39,2.5,2.5,0,1,1,2.3-4.44,56.15,56.15,0,0,0,29,5.72c6.41-.36,11.16-2.47,14.52-6.45,7.33-8.67,6.54-24.49,5.31-35.65-0.39-3.66-.89-7.09-1.36-10.29-2.54-17.22-14.53-28.46-31.29-29.35a2.5,2.5,0,0,1,.26-5c19.28,1,33.06,13.9,36,33.61,0.46,3.11,1,6.74,1.39,10.48,1.33,12.06,2.11,29.28-6.46,39.42-4.24,5-10.31,7.77-18.06,8.21Q431,632.47,429,632.47Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.18,596.7a81.41,81.41,0,0,0,11.09,8.77l13.92-2.08L396,593s8.63-2.25,9.18-8.52a3.48,3.48,0,0,0,0-.44c0-2,0-11-4.16-24.08,0,0,22.93,4.77,34.59,3.54,4.19-.44,8.65-3,12.64-6.2,8-6.32,12.68-22.53,9-32l-0.07-.18c-5.53-13.89-10.91-2.3-10.91-2.3s-4.63-11.15-12.08-10.43-9.79,12.43-9.79,12.43a117.08,117.08,0,0,0-43,7.32c-27.19,10.3-16.06,28.16-16.06,28.16S346.22,571.37,370.18,596.7Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.88,602.54c-1.14-11.08-10.89-19.51-22-18.44a18.55,18.55,0,0,0-6.75,2c-12.64,6.49-2.44,37,29.86,27.57Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M381.48,617.88c-12.8,0-21.37-6.79-24.66-15.06-3.12-7.85-.94-15.84,5.19-19a21.09,21.09,0,0,1,7.65-2.22c12.33-1.2,23.42,8.09,24.71,20.67a2.5,2.5,0,1,1-5,.51,17.9,17.9,0,0,0-19.25-16.21,16.12,16.12,0,0,0-5.85,1.69c-3.79,1.95-5,7.29-2.83,12.69,3.16,7.95,13.14,15.4,30.85,10.25a2.5,2.5,0,1,1,1.4,4.8A43.89,43.89,0,0,1,381.48,617.88Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M425.69,304a2.5,2.5,0,0,1-2.5-2.5V289.94a2.5,2.5,0,0,1,5,0v11.58A2.5,2.5,0,0,1,425.69,304Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M443.15,309.9H431.57a2.5,2.5,0,0,1,0-5h11.58A2.5,2.5,0,0,1,443.15,309.9Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M425.69,327.36a2.5,2.5,0,0,1-2.5-2.5V313.28a2.5,2.5,0,0,1,5,0v11.58A2.5,2.5,0,0,1,425.69,327.36Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M419.8,309.9H408.23a2.5,2.5,0,0,1,0-5H419.8A2.5,2.5,0,0,1,419.8,309.9Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1166.88,888.93a2.5,2.5,0,0,1-2.5-2.5V879a2.5,2.5,0,0,1,5,0v7.4A2.5,2.5,0,0,1,1166.88,888.93Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1178,892.69h-7.4a2.5,2.5,0,0,1,0-5h7.4A2.5,2.5,0,0,1,1178,892.69Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1166.88,903.85a2.5,2.5,0,0,1-2.5-2.5V894a2.5,2.5,0,0,1,5,0v7.4A2.5,2.5,0,0,1,1166.88,903.85Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1163.11,892.69h-7.4a2.5,2.5,0,0,1,0-5h7.4A2.5,2.5,0,0,1,1163.11,892.69Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M592.78,780.37a2.5,2.5,0,0,1-2.5-2.5V766.29a2.5,2.5,0,0,1,5,0v11.58A2.5,2.5,0,0,1,592.78,780.37Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M610.24,786.25H598.66a2.5,2.5,0,0,1,0-5h11.58A2.5,2.5,0,0,1,610.24,786.25Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M592.78,803.71a2.5,2.5,0,0,1-2.5-2.5V789.63a2.5,2.5,0,0,1,5,0v11.58A2.5,2.5,0,0,1,592.78,803.71Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M586.89,786.25H575.32a2.5,2.5,0,0,1,0-5h11.58A2.5,2.5,0,0,1,586.89,786.25Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 349.75,
    cy: 456.08,
    r: 8.61
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1310.94,
    cy: 1065.85,
    r: 16.83
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 739.92,
    cy: 1095.17,
    r: 14.01
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteDesign);
export default __webpack_public_path__ + "static/media/WebsiteDesign.4ba94a7df4b77303bcca02822d8a9c08.svg";
export { ForwardRef as ReactComponent };